
import { Injectable } from '@angular/core';
import { AbstractNavigationItemsService, Navigation } from '@discoverer/app-core';
import { FuseNavigationItem } from '@discoverer/fuse/components/navigation';
import { Observable, of } from 'rxjs';
export const APP_NAVITEMS: FuseNavigationItem = {
    id: 'app',
    title: 'App',
    type: 'group',
    icon: 'heroicons_outline:chart-bar',
    children: [
        {
            id: 'component',
            title: 'Products',
            type: 'basic',
            icon: '',
            link: '/ehsp/reports/component/default'
        },
        {
            id: 'sds',
            title: 'SDS Component',
            type: 'basic',
            icon: '',
            link: '/ehsp/reports/sds/default'
        },
        {
            id: 'pollutants',
            title: 'Pollutants',
            type: 'basic',
            icon: '',
            link: '/ehsp/reports/pollutants/default'
        },
        {
            id: 'booth',
            title: 'Booths',
            type: 'basic',
            icon: '',
            link: '/ehsp/booths'
        }
    ]
}


export const navItems: FuseNavigationItem[] = [APP_NAVITEMS];

@Injectable()
export class NavigationItemsService extends AbstractNavigationItemsService {
    loadItems(option: any): Promise<Navigation> {
        throw new Error('Method not implemented.');
    }
    public override getNavigationItems(): Observable<Navigation> {
        return of(
            {
                mainTitle: 'EHSP',
                items: navItems
            });
    }
}

